import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Tippy from './ReactTippy';

import { compressImage } from '@bld/bld-libs/utils';

import InfinityScrollLoad from './InfinityScrollLoad';
import dialogLoader from '../utilities/dialogLoader';
import fetchMg from '../utilities/fetchManager';

import ImageUtility from '../utilities/imageUtility';
import { messageUtility } from '../utilities/messageUtility';
import { isLoginUserPartner } from '../utilities/roleUtility';
import { isNullOrEmpty, deleteControlCode } from '../utilities/stringUtil';

import { REQUEST_PARAMS, PREFECTURE_GROUPS } from '../utilities/constants';

import RequireIcon from './RequireIcon';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { TrashIcon } from './icons/TrashIcon';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import { ClearIcon } from './icons/ClearIcon';
import SafetyDocItemIcon from './SafetyDocItemIcon';
import CcusRequireIcon from './CcusRequireIcon';
import ItemIcon from './ItemIcon';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';

moment.locale('ja');

/**
 * 利用者詳細・編集（協力会社）画面で使う
 * ※FormDropDownSingleSelectの検索枠ラジオボタンや選択ボタンがないバージョン
 */
export class FormDropDown extends React.Component {
  constructor(props) {
    super(props);

    let selected = props.defaultValue;

    if (!_.isObject(selected) || !selected.id) {
      selected = null;
    }

    this.state = {
      show: false,
      list_data: [],
      selected,
      params: _.merge(
        {
          offset: 0,
          limit: 10,
        },
        // パラメータ
        props.params
      ),
    };

    // ユニークな名前づけ
    this.name = `dropdown_${_.uniqueId()}`;
  }

  async componentDidMount() {
    const list = await this.loadItem(() => {}, null, true);

    // 初回ロード時だけ実行する
    if (this.props.setDefaultValue) {
      const selected = this.props.setDefaultValue(list);

      if (_.isObject(selected)) {
        this.setState({ selected });
      }
    }
  }

  /**
   * API呼び出し
   *
   * @param {*} notify
   * @param {*} params
   * @param {*} newFlag
   * @param {*} [props=this.props]
   * @returns
   * @memberof FormDropDown
   */
  async loadItem(notify, params, newFlag, props = this.props) {
    if (props.disabled && !newFlag) {
      return; // disabled ならロードしない
    }

    if (props.apiPath) {
      const { apiPath } = props;
      let listData = this.state.list_data;

      params = _.merge(params, props.params);
      if (_.isEmpty(params)) {
        params = this.state.params;
      }

      if (!newFlag) {
        params.offset = listData.length;
      } else {
        params.offset = 0;
      }

      // console.log(
      //   'CommonFormComponents.jsx FormDropDown loadItem',
      //   apiPath,
      //   params
      // );

      const data = await fetchMg
        .GetAjax(apiPath, params)
        .catch(() => ({ result: false }));

      if (data.result) {
        const list = data.data.entities[props.entitiesKey];
        if (_.isArray(list)) {
          if (newFlag) {
            listData = list;
          } else {
            listData = listData.concat(list);
          }

          if (list.length === 0) {
            notify('end');
          }

          this.setState({ list_data: listData, params });
          // 通信終了
          notify();

          return list;
        }
      }
    }

    return [];
  }

  /**
   * 元請設定
   *
   * @returns
   * @memberof FormDropDown
   */
  setItems() {
    const key = this.props.itemKey || 'name';

    return _.map(this.state.list_data, (val, index) => (
      <li
        className='single-select__item'
        key={`single-select__item___no.${index}`}
      >
        {/* 元請会社名 */}
        <div className='single-select__label'>{val[key]}</div>
      </li>
    ));
  }

  render() {
    if (this.props.disabled) {
      return (
        <ul
          className={
            this.props.readOnly
              ? 'single-select single-select--read-only'
              : 'single-select'
          }
        >
          {this.setItems()}
        </ul>
      );
    }
    const is_display = 'dropdown dropdown-single-select show';

    return (
      <div className='dropdown-single-select dropdownselect'>
        <div className={is_display}>
          {/* 次の項目はずらす */}
          <div className='dropdown-shift__item'>
            <div className='dropdown-single-select__scroll' id={this.name}>
              <ul className='single-select'>
                {this.setItems()}
                <InfinityScrollLoad
                  targetId={this.name}
                  callback={this.loadItem.bind(this)}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * @description ドロップダウンのラジオ選択項目
 * @param {object} option キープラン情報
 * @param {boolean} checked true: 選択, false: 未選択
 * @param {int} targetId ユニークID
 * @param {function} handleSelectedRow ラジオボタンチェック
 * @param {string} forId ラベルID用のID
 * @param {object} children 任意; ラベルの表示テキストなど → {option.name}
 */
export const FormDropdownRadio = ({
  children,
  option,
  checked,
  targetId,
  column = null,
  handleSelectedRow,
  forId = 'dropdown',
  label = '',
  className = '',
}) => (
  <li className={`single-select__item ${className}`}>
    <label
      className='radio'
      htmlFor={`${forId}-${option.id ? option.id : option[column]}-${targetId}`}
    >
      <input
        id={`${forId}-${option.id ? option.id : option[column]}-${targetId}`}
        type='radio'
        checked={checked}
        onChange={() =>
          handleSelectedRow(option[_.isNull(column) ? 'id' : column], true)
        }
      />
      <RadioButtonIcon className='icon--1_6x' />
      <span className='single-select__label-text'>
        {children
          ? children
          : option[
              _.isNull(column) ? 'name' : !_.isEmpty(label) ? label : column // labelを消してchildrenにした方がいい
            ]}
      </span>
    </label>
  </li>
);

/**
 * @description 【管理会社選択プルダウン用】ドロップダウンのラジオ選択項目
 * @param {object} children ラベルの表示テキスト
 * @param {object} option 会社情報
 * @param {boolean} checked true: 選択, false: 未選択
 * @param {int} targetId ユニークID
 * @param {Array} columns 選択した会社を一意に定めるために必要なカラム名配列
 * @param {function} handleSelectedRow ラジオボタンチェック時ハンドラ
 * @param {string} forId ラベルID用のID
 */
export const FieldTreeAllCompaniesDropdownRadio = ({
  children = '',
  option,
  checked,
  targetId,
  columns = [],
  handleSelectedRow,
  forId = 'dropdown',
}) => {
  return (
    <li className='single-select__item'>
      <label
        className='radio'
        htmlFor={`${forId}-${
          option.id ? option.id : option[columns[0]]
        }-${targetId}`}
      >
        <input
          id={`${forId}-${
            option.id ? option.id : option[columns[0]]
          }-${targetId}`}
          type='radio'
          checked={checked}
          onChange={() =>
            handleSelectedRow(
              option,
              _.isEmpty(columns) ? ['id'] : columns,
              true
            )
          }
        />
        <RadioButtonIcon className='icon--1_6x' />
        <span className='single-select__label-text'>{children}</span>
      </label>
    </li>
  );
};

/**
 * @description ドロップダウンの「選択を解除する」ボタンコンポーネント
 * @param {object} onClick ボタンクリックに実行するfunction
 */
export const FormDropdownClearButton = ({ onClick }) => (
  <button className='btn--sub btn--icon btn--filled' onClick={onClick}>
    <ClearIcon className='icon--2x' />
    選択を解除する
  </button>
);

/**
 * @description シングルセレクトコンポーネント
 * 現場・利用者 マスタ編集画面で使う
 */
export class FormDropDownSingleSelect extends React.Component {
  constructor(props) {
    super(props);

    let selected = props.defaultValue;

    if (!_.isObject(selected) || !selected.id) {
      selected = null;
    }

    this.state = {
      show: false,
      list_data: [],
      selected,
      display_label: selected
        ? this.getSelectedItemName(selected)
        : props.label,
      params: _.merge(
        {
          offset: 0,
          limit: REQUEST_PARAMS.parentLimit,
        },
        props.params
      ),
      selectedIdType: props.selectedIdType || 'id',
      selectedValue: props.selectedValue,
      disabledButShow: props.disabledButShow || false,
      isLoading: true, // ロード中フラグ
    };

    this.props_params = _.clone(props.params);

    // submitしたかのフラグ
    this.submit_flg = false;

    // ユニークな名前づけ
    this.name = `${props.label}_${_.uniqueId()}`;

    this.hidden = e => {
      if (e) {
        if (
          !_.isNull(this.parent.current) &&
          this.parent.current.contains(e.target)
        ) {
          return;
        }
      }

      if (this.state.show) {
        // コンポーネントがオープン状態の場合
        if (_.isNull(this.state.selected)) {
          // 要素が未選択の場合
          this.props.callback('');
        }
        this.setState({ show: false });
      }
    };

    this.parent = React.createRef();
  }

  async componentDidMount() {
    const list = await this.loadItem(() => {}, null, true);

    // 初回ロード時だけ実行する
    if (this.props.setDefaultValue) {
      const selected = this.props.setDefaultValue(list);
      if (_.isObject(selected)) {
        this.setState({ selected });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.show) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener('click', this.hidden, false);
    }
    if (!this.state.show) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener('click', this.hidden, false);
    }
    if (
      !_.isUndefined(this.props.params) &&
      !_.isNull(this.props.params) &&
      prevProps.params.name !== this.props.params.name &&
      this.props.params.name === '' &&
      this.props.params.clearFlag === true
    ) {
      const params = {
        limit: REQUEST_PARAMS.parentLimit,
        offset: 0,
      };
      this.setState({
        params,
        selected: null,
        display_label: this.props.label,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.submit_flg) {
      const selected = nextProps.defaultValue;
      if (_.isObject(selected) && selected.id) {
        if (this.state.selected && selected.id === this.state.selected.id) {
          return;
        }

        let display_label = this.getSelectedItemName(selected);
        display_label = display_label || nextProps.label;

        this.setState({ selected, display_label });

        // console.log(
        //   'CommonFormComponents.jsx FormDropDownSingleSelect componentWillReceiveProps',
        //   nextProps.defaultValue
        // );

        if (_.isFunction(this.props.callback)) {
          this.props.callback(selected);
        }
      }
    }

    if (this.props_params) {
      let is_change = false;
      _.each(nextProps.params, (val, key) => {
        // paramsが変化したかをチェック
        if (this.props.params[key] !== val) {
          is_change = true;
        }
      });

      if (is_change) {
        // 変更されていたらロード。
        return this.setState({ selected: null, isLoading: true }, () => {
          if (nextProps.isDependency) {
            if (!isNullOrEmpty(nextProps.params[nextProps.dependencyKey])) {
              nextProps.dependencyProcess(nextProps.dependencyDeleteKey);
              this.setState({ display_label: nextProps.label });
            }
            if (isNullOrEmpty(nextProps.params[nextProps.dependencyKey])) {
              nextProps.dependencyProcess(nextProps.dependencyDeleteKey);
              return this.setState({
                list_data: [],
                display_label: nextProps.label,
                isLoading: false,
              });
            }
          }
          this.loadItem(() => {}, nextProps.params, true, nextProps);
        });
      }
    } else {
      // paramsを保存
      this.props_params = _.clone(nextProps.params);
    }

    if (nextProps.apiPath !== this.props.apiPath) {
      if (this.props.fieldRegister) {
        // 新規現場登録画面の支店コンポーネントが変更された場合
        this.setState({ display_label: this.props.label, selected: null });
      }
      return this.setState({ isLoading: true }, () => {
        this.loadItem(() => {}, null, true, nextProps);
      });
    }
  }

  componentWillUnmount() {
    if (_.isFunction(this.props.event) === true) {
      // 利用者登録、編集画面(元請)内のユーザー種別を
      // 支店管理者 → 本社管理者 又は 現場監督 → 本社管理者と設定した場合
      this.props.event(this.state.selected);
    }
    document.removeEventListener('click', this.hidden, false);
  }

  async loadItem(notify, params, new_flg, props = this.props) {
    // 既に全件読み込んでいる場合は終了する
    if (
      !_.isNil(this.state.totalCount) &&
      this.state.totalCount === _.size(this.state.list_data) &&
      !new_flg
    ) {
      this.setState({ isLoading: false });
      notify(); //通信終了
      return;
    }

    if (props.disabled && !new_flg) {
      this.setState({ isLoading: false });
      return; // disabled ならロードしない
    }

    // console.log('ロード開始');

    if (props.apiPath) {
      const { apiPath } = props;
      let list_data = this.state.list_data;

      params = !isNullOrEmpty ? params : { ...this.state.params };
      params = _.merge(params, props.params);

      if (!new_flg) {
        params.offset = list_data.length;
      } else {
        params.offset = 0;
      }

      if (this.props.isApiStop) {
        this.setState({ isLoading: false });
        return;
      }

      // console.log(
      //   'CommonFormComponents.jsx FormDropDownSingleSelect loadItem',
      //   apiPath,
      //   params
      // );

      const data = await fetchMg
        .GetAjax(apiPath, params)
        .catch(() => ({ result: false }));

      // console.log(
      //   'CommonFormComponents.jsx FormDropDownSingleSelect loadItem',
      //   data
      // );

      if (data.result) {
        const list = data.data.entities[props.entitiesKey];

        if (this.props.usersPartnerForm === true && list.length > 0) {
          // 利用者詳細、編集画面(協力会社)に遷移した場合
          this.props.callback(list[0]);
          this.setState({
            selected: list[0],
            display_label: this.getSelectedItemName(list[0]),
          });
        }

        if (_.isArray(list)) {
          if (new_flg) {
            list_data = list;
          } else {
            list_data = list_data.concat(list);
          }

          if (list.length === 0) {
            notify('end');
          }

          let { selected, display_label } = this.state;
          if (this.state.selectedValue && isLoginUserPartner()) {
            selected = _.find(list_data, data => {
              return (
                String(data[this.state.selectedIdType]) ===
                this.state.selectedValue
              );
            });
            display_label = selected
              ? this.getSelectedItemName(selected)
              : display_label;
          }

          this.setState({
            list_data,
            params,
            selected,
            display_label,
            isLoading: false,
            totalCount: _.get(data, 'data.total', null),
          });
          notify(); //通信終了

          return list;
        }
      }
    } else {
      this.setState({ isLoading: false });
    }

    return [];
  }

  getSelectedItemName = selectedItem => {
    return _.isNil(this.props.itemKey)
      ? selectedItem.name
      : selectedItem[this.props.itemKey];
  };

  /**
   * 変更ボタンの押下
   *
   * @memberof FormDropDownSingleSelect
   */
  submit() {
    if (this.state.selected) {
      this.submit_flg = true;
      let display_label = this.getSelectedItemName(this.state.selected);

      // 表示を変える
      if (display_label) {
        this.setState({ display_label });
      }

      if (this.props.callback) {
        this.props.callback(this.state.selected);
      }
    }

    this.hidden(); // フォームを閉じる
  }

  setItems() {
    const selectKey = this.props.selectKey || 'id';
    const nameKey = this.props.itemKey || 'name';
    const selected = this.state.selected || {};

    return _.map(this.state.list_data, (val, i) => (
      <li className='single-select__item' key={`single-select__item___no.${i}`}>
        <label className='radio'>
          <input
            type='radio'
            name={this.name}
            readOnly
            checked={selected[selectKey] === val[selectKey]}
            onChange={() => {
              if (
                this.props.needConfirm &&
                selected[selectKey] !== val[selectKey]
              ) {
                dialogLoader.show(CancelAndConfirmDialog, {
                  title: this.props.confirmTitle,
                  message: this.props.confirmMessage,
                  confirmButtonText: messageUtility.getMessage('I-000-057'),
                  cancelButtonText: messageUtility.getMessage('I-000-008'),
                  isNegative: true,
                  onCancel: () => {
                    dialogLoader.close();
                  },
                  onConfirm: () => {
                    this.selectItem(
                      val,
                      selected[selectKey] === val[selectKey]
                    );
                    dialogLoader.close();
                  },
                });
              } else {
                this.selectItem(val, selected[selectKey] === val[selectKey]);
              }
            }}
          />
          <RadioButtonIcon className='icon--1_6x' />
          <span className='single-select__label-text'>{val[nameKey]}</span>
        </label>
      </li>
    ));
  }

  search(e) {
    if (this.search_timout_id) {
      clearTimeout(this.search_timout_id);
    }

    const str = e.target.value;

    this.search_timout_id = setTimeout(() => {
      if (_.isString(str)) {
        const params = { ...this.state.params };
        params[this.props.searchKey || 'name'] = str;
        return this.setState({ list_data: [], isLoading: true, params }, () => {
          this.loadItem(() => {}, params, true); // 検索
        });
      }
    }, 500);
  }

  /**
   * @description ドロップダウン内要素選択・選択解除
   * @param {object} item ドロップダウン内要素
   * @param {boolean} sameClickFlag true: 選択要素クリック, false: 未選択要素クリック
   */
  selectItem(item) {
    // selectItem(item, sameClickFlag) {
    if (this.props.disabledButShow) {
      return;
    }
    // 影響範囲の可能性があるため一旦コメントアウト
    // if (sameClickFlag === true && this.props.cancelItemFlag === true) {
    //   this.setState({ selected: null, display_label: this.props.label });
    // } else {
    //   this.setState({ selected: item }, () => {
    //     this.submit();
    //   });
    // }
    this.setState({ selected: item }, () => {
      this.submit();
    });
  }

  clearSelectedRow() {
    this.setState({ selected: null, display_label: this.props.label }, () => {
      this.submit();
    });
  }

  render() {
    if (this.props.isReadOnly) {
      return <div>{this.state.display_label}</div>;
    }

    const selected = this.state.selected || {};
    let is_display = 'dropdown dropdown-single-select';
    if (this.state.show && !this.props.disabled) {
      is_display += ' show';
    }

    return (
      <div className='dropdown-single-select dropdownselect' ref={this.parent}>
        <div
          className={`dropdown-single-select__header ${this.state.show &&
            'show'}`}
        >
          <input
            type='hidden'
            value={_.defaultTo(selected.id, '')}
            className='select_value'
          />
          <a
            className={`dropdown-select ${this.props.className || ''}
              ${this.props.disabled ? 'dropdown-select--disabled' : ''}`}
            onClick={e => {
              if (this.props.disabled) {
                return;
              }

              let state = { show: !this.state.show };

              //ラベルの値が、初期値に戻っていたら
              if (
                e.target.innerText === this.props.label &&
                !_.isEmpty(selected)
              ) {
                // 整合性を合わせる
                state.selected = null;
                state.display_label = this.props.label;
              }

              this.setState(state);
            }}
          >
            <span className='dropdown-select__txt'>
              {this.state.display_label}
            </span>
          </a>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
        {this.state.show && (
          <div className={is_display}>
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  defaultValue={
                    this.state.params[this.props.searchKey || 'name']
                  }
                  disabled={this.props.disabled}
                  onChange={this.search.bind(this)}
                  className={this.props.disabled ? 'static' : ''}
                />
              </div>
              {this.props.isOptional && (
                <div className='dropdown-single-select__item'>
                  <FormDropdownClearButton
                    onClick={this.clearSelectedRow.bind(this)}
                  />
                </div>
              )}
              <div className='dropdown-single-select__scroll' id={this.name}>
                <ul className='single-select'>
                  {this.setItems()}
                  <InfinityScrollLoad
                    targetId={this.name}
                    total={_.size(this.state.list_data)}
                    callback={this.loadItem.bind(this)}
                    reset={this.state.isLoading}
                    isLoading={this.state.isLoading}
                  />
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export const FormList = ({ children, isSpace = false, ...props }) => {
  const className = `${props.className || 'form-list form-list-default'} ${
    isSpace ? 'form-list-default--space' : ''
  }`;
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};

export const FormListItem = ({
  children,
  requiredText,
  label = '',
  required = false,
  isBorder = true,
  isAlignStart = false,
  isUseItemIcon = false,
  ...props
}) => {
  const className = `${props.className || 'form-list__item'} ${
    !isBorder ? 'form-list__item--no-border' : ''
  } ${isAlignStart ? 'form-list__item--align-start' : ''}`;
  const {
    isRecommended,
    safetyDocItem,
    ccusRequired,
    itemIconLabel,
    ...rest
  } = props;
  return (
    <div className={className} {...rest}>
      {label !== '' && (
        <FormListLabel
          required={required}
          label={label}
          isRecommended={isRecommended}
          isUseItemIcon={isUseItemIcon}
          itemIconLabel={itemIconLabel}
          safetyDocItem={safetyDocItem}
          ccusRequired={ccusRequired}
          requiredText={requiredText}
        />
      )}
      {children}
    </div>
  );
};

export const FormListLabel = ({
  label,
  requiredText,
  required = false,
  ...props
}) => {
  const {
    isRecommended,
    safetyDocItem,
    ccusRequired,
    isUseItemIcon,
    itemIconLabel,
    ...rest
  } = props;
  return (
    <div className='form-list__label' {...rest}>
      <span className='label'>
        {label}
        {required && (
          <RequireIcon
            isSpace={safetyDocItem || ccusRequired}
            requiredText={requiredText}
          />
        )}
        {isRecommended && <RecommendedLabel />}
        {isUseItemIcon && (
          <div className='form-list__item-icon'>
            <ItemIcon itemIconLabel={itemIconLabel} />
          </div>
        )}
        {safetyDocItem && (
          <div className='form-list__safety-doc-item-icon'>
            <SafetyDocItemIcon isFormListDefault={true} />
          </div>
        )}
        {ccusRequired && (
          <div className='form-list__ccus-required-item-icon'>
            <CcusRequireIcon />
          </div>
        )}
      </span>
    </div>
  );
};

const RecommendedLabel = () => {
  return (
    <span className='form_label__icon form_label__icon--recommended'>推奨</span>
  );
};

export const FormElement = ({
  children,
  additionalElement,
  ccusComponent = null,
  validate,
  warning,
  info,
  ...props
}) => {
  const className = `${props.className || 'form-list__element'} ${
    validate ? 'form-list__element--error' : ''
  } ${ccusComponent ? 'form-list__element--with-ccus' : ''}`;

  const subclassName = `form-list__element-main`;
  return (
    <React.Fragment>
      <div {...props} className={className}>
        <div className={subclassName}>
          {children}
          <Validation validate={validate} />
          {warning && <SupplementalWarning>{warning}</SupplementalWarning>}
          {info && <SupplementalInfo>{info}</SupplementalInfo>}
          {additionalElement}
        </div>
      </div>
      {ccusComponent && (
        <FormElementCcusBlock
          ccusComponent={ccusComponent}
          validate={!!validate}
        />
      )}
    </React.Fragment>
  );
};

export const FormElementContainer = props => {
  const { children, className, ...rest } = props;
  const classname = `form-element__container ${className ? className : ''}`;
  return (
    <div {...rest} className={classname}>
      {children}
    </div>
  );
};

export const FormElementContainerItem = props => {
  const { children, className, ...rest } = props;
  const classname = `form-element__container-item ${
    className ? className : ''
  }`;
  return (
    <div {...rest} className={classname}>
      {children}
    </div>
  );
};

export const FormElementContainerItemLabel = props => {
  const { children, className, isSpace = false, ...rest } = props;
  const classname = `form-element__container-label ${isSpace &&
    'form-element__container-label--space'} ${className ? className : ''}`;
  return (
    <div {...rest} className={classname}>
      {children}
    </div>
  );
};

const FormElementCcusBlock = ({ ccusComponent = null, validate }) => {
  return (
    <div className={`form-list__element-ccus-block `}>
      <div
        className={`form-list__element-ccus-block-main ${
          validate ? 'form-list__element-ccus-block-main--error' : ''
        }`}
      >
        {ccusComponent}
      </div>
    </div>
  );
};

/**
 * ワーニングメッセージを表示したい場合
 * @param props
 * @returns {JSX.Element}
 */
const SupplementalWarning = props => {
  return <div className='form-list__alert show'>{props.children}</div>;
};

/**
 * インフォメーションメッセージを表示したい場合
 * @param props
 * @returns {JSX.Element}
 */
const SupplementalInfo = props => {
  return <div className='form-list__supplemental-info'>{props.children}</div>;
};

export const FormListItemGroup = ({
  children,
  closeFn,
  isBorder = true,
  rightComponent,
  ...props
}) => {
  const className = `form-list__item form-list__item--open ${
    !isBorder ? 'form-list__item--no-border' : ''
  }`;
  const { label } = props;
  return (
    <React.Fragment>
      <FormListItem label={label} className={className}>
        {rightComponent}
      </FormListItem>
      {closeFn && (
        <li className='form-list__item form-list__item--child'>
          <div className='form-list__item-group-close-btn' onClick={closeFn}>
            <TrashIcon className='icon--2_4x form-list__trash-icon' />
          </div>
        </li>
      )}
      {children}
    </React.Fragment>
  );
};

export const FormListItemChild = ({
  children,
  requiredText,
  isSpace = false,
  required = false,
  isFormListItem = false,
  ...props
}) => {
  // 条件により通常のFormListItem(ネストしない方)を出力したい時に使用する
  if (isFormListItem) {
    return (
      <FormListItem required={required} {...props}>
        {children}
      </FormListItem>
    );
  }
  const className = `form-list__item form-list__item--child${
    isSpace ? ' form-list__item--child-space' : ''
  }`;
  const { label, safetyDocItem } = props;
  return (
    <React.Fragment>
      <FormListItem
        label={label}
        required={required}
        className={className}
        safetyDocItem={safetyDocItem}
        requiredText={requiredText}
      >
        {children}
      </FormListItem>
    </React.Fragment>
  );
};

export const FormListSubHeader = ({
  title = '',
  info,
  noMarginTop = false,
  rightComponent = null,
  ccusComponent = null,
}) => {
  return (
    <div
      className={`FormListSubHeader ${
        noMarginTop ? 'FormListSubHeader--no-margin-top' : ''
      }`}
    >
      <div className='FormListSubHeader__left-items'>
        <h3 className='FormListSubHeader__title'>{title}</h3>
        {info && <div className='FormListSubHeader__info'>{info}</div>}
      </div>
      {ccusComponent && (
        <div className='FormListSubHeader__ccus-component'>{ccusComponent}</div>
      )}
      {rightComponent && (
        <div className='FormListSubHeader__right-items'>{rightComponent}</div>
      )}
    </div>
  );
};

/**
 * 数字付きヘッダー
 * ex) 1. Title
 * @param {String} number: ヘッダーNo.
 * @param {String} title: タイトル
 * @param {String} info: タイトル捕捉文
 * @param {String} rootClassName: クラス名
 * @param {Boolean} noMarginTop: cssのmarginを設定しないか？
 * @returns {JSX.Element}
 **/
export const FormListSubNumberHeader = ({
  number,
  title = '',
  titleInfo,
  info,
  rootClassName,
  noMarginTop = false,
}) => {
  return (
    <div
      className={`FormListSubNumberHeader ${
        noMarginTop ? 'FormListSubNumberHeader--no-margin-top' : ''
      } ${rootClassName ? rootClassName : ''}`}
    >
      <div className='FormListSubNumberHeader__left-items'>
        <h3 className='FormListSubNumberHeader__title'>
          {number && (
            <span className='FormListSubNumberHeader__title__number'>
              {number}
            </span>
          )}
          {title}
          {titleInfo && (
            <span className='FormListSubNumberHeader__title__info'>
              {titleInfo}
            </span>
          )}
        </h3>
        {info && <div className='FormListSubNumberHeader__info'>{info}</div>}
      </div>
    </div>
  );
};

export const CcusTranscriptionFormBlock = ({ children, ccusComponent }) => {
  return (
    <React.Fragment>
      {ccusComponent && (
        <FormListItem isBorder={false}>
          <FormElement ccusComponent={ccusComponent} />
        </FormListItem>
      )}
      {children}
    </React.Fragment>
  );
};

export const Validation = ({ validate }) => {
  let class_name = 'form-list__alert';
  if (validate) {
    class_name += ' show';
  }
  if (!_.isString(validate)) {
    validate = '';
  }

  return <div className={class_name}>{validate}</div>;
};

export const InputForm = ({
  name,
  type,
  value,
  params,
  disabled,
  onUpdate,
  onValidationCheck,
  className,
  maxLength,
  placeholder,
  contentEditable,
  style,
  accept,
}) => {
  // console.log(
  //   'CommonFormComponents.jsx InputForm',
  //   name,
  //   type,
  //   value,
  //   params,
  //   disabled,
  //   onUpdate,
  //   onValidationCheck,
  //   className,
  //   maxLength,
  //   placeholder,
  //   contentEditable,
  //   style,
  //   accept
  // );
  return (
    <input
      name={name}
      type={_.defaultTo(type, 'text')}
      value={_.defaultTo(value, '')}
      checked={value}
      placeholder={placeholder}
      className={
        disabled
          ? `static ${className ? className : ''}`
          : `${className ? className : ''}`
      }
      disabled={!!disabled}
      maxLength={maxLength}
      contentEditable={contentEditable}
      accept={accept}
      onChange={e => {
        onUpdate(deleteControlCode(e.target.value), params, e.target);
      }}
      onBlur={() => {
        onValidationCheck();
      }}
      style={style}
    />
  );
};

let thum_ref = null;

/**
 * @description type="file" の input Component
 */
export const FileInputForm = ({
  value,
  alt,
  disabled,
  onUpdate,
  validate,
  info,
}) => (
  <FormElement info={info}>
    <div className='form-list__img'>
      <div
        className='img-form-thumbnail'
        ref={r => {
          thum_ref = r;
        }}
      >
        {(() => {
          if (!_.isEmpty(value)) {
            return <img src={value} alt={alt} />;
          }
        })()}
      </div>
      {!disabled && (
        <button
          type='button'
          className='btn-icon form-list__element--btn_delete'
          onClick={() => {
            onUpdate({});
            thum_ref.style.width = '';
            thum_ref.style.height = '';
          }}
        >
          {' '}
          <TrashIcon className='icon--2_4x form-list__trash-icon' />
        </button>
      )}
    </div>
    <div style={{ width: '100%', marginTop: 10 }}>
      {(() => {
        if (!disabled) {
          return (
            <Tippy
              html={renderTooltipContent({
                text: messageUtility.getMessage('I-000-223'),
              })}
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
            >
              <label className='btn input-file'>
                ファイル選択
                <InputForm
                  type='file'
                  accept='image/png,image/jpeg,image/gif'
                  onUpdate={async (value, params, target) => {
                    if (target.files.length > 0) {
                      const file = target.files[0]; //ファイルを取得
                      const size = await ImageUtility.fileSizeCheck(file);
                      const type = await ImageUtility.fileTypeCheck(file);
                      if (!size) {
                        dialogLoader.show(
                          dialogErrorMessage,
                          {
                            callback: {
                              done: () => {
                                dialogLoader.close();
                              },
                            },
                            message: messageUtility.getMessage('E-000-011'),
                          },
                          null
                        );
                        return;
                      }
                      if (!type) {
                        dialogLoader.show(
                          dialogErrorMessage,
                          {
                            callback: {
                              done: () => {
                                dialogLoader.close();
                              },
                            },
                            message: messageUtility.getMessage('E-000-012'),
                          },
                          null
                        );
                        return;
                      }

                      let img = new Image();

                      img.onload = () => {
                        const width = img.naturalWidth;
                        const height = img.naturalHeight;
                        const max = 350;
                        let ratio = 1;

                        if (width > max || height > max) {
                          ratio = width / max;
                          if (ratio <= height / max) {
                            ratio = height / max;
                          }
                        }

                        thum_ref.style.width = `${Math.floor(width / ratio)}px`;
                        thum_ref.style.height = `${Math.floor(
                          height / ratio
                        )}px`;
                      };

                      const reader = new FileReader();
                      reader.onload = () => {
                        // ファイル読み込み成功時
                        const binary = reader.result; // base64バイナリを取得
                        // TODO: これがあると画像が小さくなるのでコメントアウト
                        // img.src = binary;
                        onUpdate(binary);
                      };

                      compressImage(file, result =>
                        reader.readAsDataURL(result)
                      );
                    }
                  }}
                />
              </label>
            </Tippy>
          );
        }
      })()}
    </div>
    <Validation validate={validate} />
  </FormElement>
);

/**
 * @description 時間のoptionを返す。
 */
export const SelectOptionTimeTemplate = ({ start, step, id, end }) => {
  let option = [];
  let n = moment(`2018/01/01 ${start}`, 'YYYY/MM/DD HH:mm');
  let i = 0;

  while (i < 96) {
    const val = n.format('HH:mm');
    option.push(
      <option value={`${val}:00`} key={`${id}-${i}`}>
        {val}
      </option>
    );

    if (val.match(end)) {
      break;
    }

    n.add(step, 'm');
    i++;
  }

  return option;
};

export const WorkHourSelectOptionTimeTemplate = ({ start, step, id, end }) => {
  let option = [];
  let n = moment(`2018/01/01 ${start}`, 'YYYY/MM/DD HH:mm');
  let i = 0;

  while (i < 96) {
    const val = n.format('HH:mm');
    const displayVal = n.format('H:mm');
    option.push(
      <option value={`${val}:00`} key={`${id}-${i}`}>
        {displayVal} 時間
      </option>
    );

    if (val.match(end)) {
      break;
    }

    n.add(step, 'm');
    i++;
  }

  return option;
};

/**
 * @description 都道府県選択
 */
export class FormPrefecturesSelect extends React.Component {
  constructor(props) {
    super(props);
    this.lists = [];
    this.state = {
      default_value: null,
      selected: '',
    };
  }
  componentDidUpdate(newProps, newState) {
    //初期値
    if (newProps.default_value !== this.props.default_value) {
      this.setState({
        selected: this.props.default_value,
      });
      return;
    }
    //更新
    if (newProps.value !== this.props.value) {
      this.setState({
        selected: this.props.value,
      });
      return;
    }
    //イベントからの更新
    if (newState.selected !== this.state.selected) {
      this.setState({
        selected: this.props.value,
      });
    }
  }

  change(e) {
    this.setState({ selected: e.target.value });
    this.props.onUpdate(e.target.value, this.props.params, e.target);
  }

  render() {
    return (
      <React.Fragment>
        <select
          name={name}
          value={_.defaultTo(this.state.selected, '')}
          disabled={this.props.disabled}
          onChange={e => {
            this.change(e);
          }}
          onBlur={() => {
            this.props.onValidationCheck();
          }}
        >
          <option value='' disabled>
            都道府県を選択
          </option>
          {_.map(PREFECTURE_GROUPS, (region, index) => (
            <optgroup key={index} label={region.label}>
              {_.map(region.prefectures, prefecture => (
                <option key={prefecture.id} value={prefecture.name}>
                  {prefecture.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
        <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
      </React.Fragment>
    );
  }
}

export const TextInput = props => {
  return props.disabled ? <span>{props.value}</span> : <input {...props} />;
};

/**
 * エラーダイアログ
 */
const dialogErrorMessage = props => {
  return (
    <div
      className='dialog-sm dialog--modal'
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>登録失敗</span>
      </div>
      <div className='dialog-sm__body'>
        <p>
          <span className='text--muted'>{props.dialog.message}</span>
        </p>
      </div>
      <div className='dialog-sm__footer'>
        <button
          className='btn--sub'
          onClick={() => {
            props.dialog.callback.done();
          }}
        >
          了解
        </button>
      </div>
    </div>
  );
};

/**
 * ツールチップ
 * @param text {string}
 */
const renderTooltipContent = ({ text }) => {
  return (
    <React.Fragment>
      <div className='tippy-tooltip__text'>{text}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/CommonFormComponents.jsx